import { LegalDocSet } from '../legal-doc.model';
import { CHRONIQ_PRIVACY_DE } from './chroniq-privacy.de';
import { CHRONIQ_PRIVACY_EN } from './chroniq-privacy.en';
import { CHRONIQ_PRIVACY_FR } from './chroniq-privacy.fr';
import { CHRONIQ_PRIVACY_IT } from './chroniq-privacy.it';

/**
 * Chroniq addresses employees in Romandie and Ticino, so its privacy policy exists
 * in all four languages — the German text is the authoritative one.
 */
export const CHRONIQ_PRIVACY: LegalDocSet = {
    de: CHRONIQ_PRIVACY_DE,
    en: CHRONIQ_PRIVACY_EN,
    fr: CHRONIQ_PRIVACY_FR,
    it: CHRONIQ_PRIVACY_IT,
};
